module.exports = __webpack_public_path__ + "static/img/110113.8fcfaf1d.png";